import React, { useState, useEffect, useRef } from 'react';
import { Button, Input } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import * as icons from '../../assets/images/toolbarIcons/_toolbarIcons';
import './Opacity.css';

let target;
const CSS2JS = css => {
  if (css) {
    let frameCSS = css.replace(/([\w-.]+)\s*:([^;]+);?/g, '$1:$2,');
    frameCSS = frameCSS.replace(/,+$/, '');
    let properties = frameCSS.split(', ');
    let frameCSSObj = {}; // as { [key: string]: number };
    properties.forEach(function (property) {
      let cssProp = property.split(':');
      // let cssKey = cssProp[0].toCamelCase();
      let cssKey = cssProp[0].trim();
      let cssValue = cssProp[1].trim();
      frameCSSObj[cssKey] = cssValue;
      // frameCSSObj = frameCSSObj.Push(cssProp) //= frameCSSObj + cssProp;
    });

    return frameCSSObj;
  }
};

const Opacity = props => {
  const dispatch = useDispatch();
  const [opacity, setOpacity] = useState();
  const [sliderBox, setSliderBox] = useState();
  const [targetId, setTargetId] = useState();
  const [firstLoad, setFirstLoad] = useState();
  const [opacityDD, setOpacityDD] = useState();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 650) {
      setIsMobile(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setOpacityDD(document.getElementById('opacityDD'));
  });

  useEffect(() => {
    if (typeof props.targetId === 'string') {
      setTargetId(props.targetId);
      setFirstLoad(1);
      target = document.getElementById(`B_${props.pageId}`);
      let elOpacity = target.style.opacity;
      if (!elOpacity) {
        setOpacity(100);
        target.style.opacity = 1;
      } else {
        if (elOpacity != opacity / 100) {
          setOpacity(Math.round(elOpacity * 100));
        }
      }
    } else {
      [...document.querySelectorAll('[data-target]')].map(element => {
        const targetKey = parseInt(element.dataset.target.split('_')[1]);
        setTargetId(props.targetId);
        if (targetKey == props.targetId) {
          setFirstLoad(1);
          target = element;
          let elOpacity = target.style.opacity;
          if (!elOpacity) {
            setOpacity(100);
            target.style.opacity = 1;
          } else {
            if (elOpacity != opacity / 100) {
              setOpacity(Math.round(elOpacity * 100));
            }
          }
        }
      });
    }
  }, [props.targetId]);

  useEffect(() => {
    if (isMobile) {
      if (opacityDD) {
        // document.getElementById('workplace').appendChild(opacityDD);
      }
      if (sliderBox) {
        document.getElementById('opacityDD').style.display = 'block';
      } else {
        document.getElementById('opacityDD').style.display = 'none';
      }
    }
  }, [sliderBox]);

  const handleChange = (e, { name, value }) => {
    target.style.opacity = value / 100;
    setOpacity(value);
  };

  const mouseUpHandler = () => {
    const data = {
      master: CSS2JS(target.style.cssText),
    };
    dispatch(designActions.changeEntityStyle(props.pageId, props.targetId, data));
  };
  const toggleSlider = () => {
    if (sliderBox) {
      setSliderBox(false);
    } else {
      setSliderBox(true);
    }
  };

  const useOutsideClick = ref => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (sliderBox) {
          setSliderBox(false);
        }
      }
    };

    useEffect(() => {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on  clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  };

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  const rangeItem = (
    <div id="opacityDD" className="sliderBox" ref={wrapperRef}>
      <Input
        label={opacity}
        min={0}
        max={100}
        name="duration"
        onChange={handleChange}
        onMouseUp={mouseUpHandler}
        step={1}
        type="range"
        value={opacity}
      />
    </div>
  );
  return (
    <>
      <Button title="Opacity" onMouseDown={toggleSlider} className="opacityBtn">
        <ReactSVG src={icons.opacity} />
      </Button>
      {isMobile ? rangeItem : sliderBox && rangeItem}
    </>
  );
};

Opacity.propTypes = {
  pageId: PropTypes.number,
  targetId: PropTypes.number,
};

export default Opacity;
